const global = {
  defaultSystemName: '众寻・智慧位置服务系统',
  alarmHandle: '告警处理',
  alarmHandleDescription: '请输入告警处理说明!',
  alarmHandleSuccess: '处理告警成功！',
  selectTime: '选择时间',
  selectDate: '选择日期',
  event: '事件',
  noramlAlarm: '一般告警',
  importantAlarm: '重要告警',
  fearfulAlarm: '严重告警',
  processed: '已处理',
  undisposed: '未处理',
  showAlarmPosition: '查看告警地点',
  fenceAlarm: '围栏告警',
  today: '今天',
  lastThreeDays: '近三天',
  lastSevenDays: '近七天',
  lastThirtyDays: '近三十天',
  thisWeek: '本周',
  thisMounth: '本月',
  tomorrow: '明天',
  alarmType: '告警类型',
  alarmTime: '告警时间',
  alarmLevel: '告警级别',
  alarmStatu: '告警状态',
  alarmPosition: '告警地点',
  alarmDescription: '告警描述',
  alarmAction: '操作',
  totalRecords: '共{num}条记录',
  operator: '经办人',
  description: '描述',
  time: '时间',
  location: '地点',
  OK: '确定',
  slow: '慢',
  verySlow: '非常慢',
  noraml: '普通',
  fast: '快',
  veryFast: '非常快',
  noInfo: '没有信息',
  trackSearch: '轨迹查询',
  personalTrack: '个人轨迹',
  stayTime: '停留时间',
  occurAlarm: '发生告警',
  reason: '原因',
  alarmInfo: '告警信息',
  basicInfo: '基本信息',
  allPoints: '所有点',
  stayPoints: '停留点',
  alarmPoints: '告警点',
  movePoints: '运动点',
  inputFliterTip: '请输入过滤条件',
  edit: '编辑',
  commitSuccess: '提交修改成功!',
  resetPassword: '密码重置',
  oldPassword: '原密码',
  oldPasswordTip: '请输入原密码！',
  newPassword: '新密码',
  newPasswordTip: '请输入新密码！',
  confirmPassword: '确认密码',
  confirmPasswordTip: '请输入密码确认！',
  confirmError: '两次输入的密码不一致！',
  resetPasswordSuccess: '重置密码成功！',
  upload: '上传',
  delete: '删除',
  tips: '提示',
  imgTypeTip: '请上传.png .jpg .jpeg .bmp格式的图片文件',
  imgPngTip: '请上传.png或.jpg图片文件',
  imgSizeTip: '请上传小于1MB的图片文件',
  set: '设置',
  none: '未设置',
  enable: '启用',
  disable: '失效',
  loading: '加载中...',
  nonsupport: '不支持',
  yes: '是',
  no: '否',
  forbidIn: '禁入',
  forbidOut: '禁出',
  call: '点名',
  dispose: '处理',
  currentOrg: '当前机构',
  all: '全选',
  hello: '您好， ',
  logout: '退出',
  selectedNum: '已选择{num}项',
  confirm: '您确定要这么做吗？',
  create: '新增',
  org: '所属机构',
  export: '导出',
  moreOperation: '更多操作',
  second: '秒',
  minute: '分钟',
  hour:'小时',
  detail: '详情',
  action: '操作',
  cancel: '取消',
  next: '下一步',
  pre: '上一步',
  exportList: '导出列表',
  deleteConfirm: '确认删除?',
  checkXlsx: '请上传.xlsx类型的文件',
  import: '导入',
  changeBelong: '修改机构/分组',
  bind: '绑定',
  unbind: '解绑',
  absent: '请假',
  option: '配置',
  track: '轨迹',
  fence: '围栏',
  onAbsent: '请假中',
  preAbsent: '预请假',
  isRequired: '不能为空',
  modify: '修改',
  noramlAbsent: '正常',
  helpDocs: '帮助',
  download: '下载',
  deviceDocs: '设备文档',
  systemDocs: '系统文档',
  scanQRToDownload: '扫描二维码下载APP',
  androidAPPDocs: 'APP文档',
  wxminAppDocs: '小程序文档',
  scanQRToWXapp: '请使用微信扫描二维码打开智能腕锁小程序',
  status: '状态',
  normal: '采集完成',
  collection: '采集中...',
  terminal: '操作终端',
  collectFailed:'采集失败',
  chinese: '中文',
  english: '英语',
  russian: '俄语', 
  timesPerMinute:'次/分钟',
  temperature:'℃',
  登陆:'登陆',
  分组:'分组',
  人员:'人员',
  其他:'其他',
  短信:'短信',
  邮件:'邮件',
  设备:'设备',
  系统:'系统',
  创建子用户:'创建用户',
  passwordLengthTip:'密码长度在6-15之间',
  普管组:"普管组",
  宽管组:"宽管组",
  严管组:"严管组",
  successful:'操作成功',
  moveDevice:'移动设备到',
  personalConfigTip:'个人配置优先于分组配置生效,当个人配置存在的时候会覆盖分组配置,生效的配置始终以深色字体表现。',
  sureDelete:'你确定要删除吗？',
  deleteUserSuccessTip:'删除用户成功',
  入矫:'入矫',
  入组:'入组',  
  broadcast:'广播消息',
  broadcastList:'广播列表',
  send:'发送',
  receiver:'接收人',
  broadcastTip:'请输入广播内容，长度在67个字内，不要使用特殊字符！',
  broadcastCount:'广播次数',
  broadcastInterval:'广播间隔(秒)',
  close:'关闭',
  total:'共',
  people:'人',
  sender:'发送人',
  content:'信息内容',
  searchTip:'请输入搜索内容！',
  none:'暂无信息',
  pleaseSelectAScene:"请选择场景",
  sendingStatus:'发送状态',
  fscg:'人发送成功',
  fssb:'人发送失败',
  qz:'其中',
  yd:'人已读',
  read:'已读',
  unread:'未读',
  inProgress:'人正在执行',
  resend:'重发',
  cg:'成功',
  sb:'失败',
  wlbd:'失败(网络波动)',
  zxz:'执行中',
  sbzxsb:'设备执行失败',
  cs:'失败(超时)',
  wbdsb:'失败(未绑定设备)',
  zt:'状态',
  dwfs:'定位方式:',
  dwpl:'定位采集频率',
  gpsyx:'GPS开关',
  smtzkg:'生命体征开关',
  pdjckg:'佩戴检测开关',
  zdjpkg:'自动降频开关',
  enableShake:'震动开关',
  qsrdz:'请输入要定位的地址',
  clj:'长连接',
  zxwzfwxt:"众寻·全场景位置服务系统",
  "中文":'中文',
  "英文":'英文',
  "俄语":'俄语',
  qsrdz:'请输入要定位的地址',
  很抱歉没有查询到轨迹记录:'很抱歉没有查询到轨迹记录',
  cxfs:'重发消息成功！请稍后查看结果',
  提示:'提示',
  确认将:'确认将当前分组修改卫默认分组吗？',
  enableSos:'SOS开关',
  healthFreq:'健康采样频率',
  sxbdkkg:'打卡开关',
  gzms:'工作模式',
  powerSaveMode:'省电模式',
  balanceMode:'平衡模式',
  realTimeMode:'实时模式',
  shakeUploadMode:'震动上传模式',
  continuousLocateMode:'持续定位模式',
  xmsjd:'休眠时间',
  startTimeTip:'选择开始时间',
  endTimeTip:'选择结束时间',
  qxhm:'亲情号码',
  yltj:'音量调节',
  xzrq:'选择固定时间',
  allTrack:'全部轨迹',
  inTrack:'室内轨迹',
  outTrack:'室外轨迹',
  secondOnce:'秒一次',
  filterDistance:'轨迹点过滤门限',
}
export default global
